module.exports = __webpack_public_path__ + "static/media/hero.2e98d4b0.jpg";